export const FORM_NAME = 'UPLOAD_SHEET';
export const ALLOWED_MIME_TYPES = ['.csv', 'text/csv'].join(', ');
